import { Component, OnInit, ViewChild,AfterViewInit, Renderer } from '@angular/core';
import { UserService } from 'app/services/user.service';
declare var $;
class Usuario {
  username:string;
  password:string;
  ;
  constructor(){
    this.username = null;
    this.password = null;
  }
}
@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit,AfterViewInit {
  public formulario:Usuario;
  @ViewChild('dataTable',{static:false}) table;
  public selected = true
  public dataTable:any;
  public options;
  public dtOptions: any= {};
  constructor(private _userService:UserService, private _render:Renderer) {
    this.formulario = new Usuario();
    
  }
  
  public guardarUsuario():Usuario{
    this._userService.guardar().subscribe(this.cargarVista, this.error);
    return this.formulario;
  }
  public cargarVista(data){
    console.log(data)
  }
  /**
   * error
   */
  public error(error) {
    console.error(error)
  }
  /* LifeCycle hooks  */
  ngOnInit() {
    console.log(this.table);
    this.dtOptions = {
      columns: [
        {       
          title: 'Primer Nombre',
          data: 'primerNombre'
        },
        {
          title: 'Segundo nombre',
          render:(data: any, type: any, full: any)=>{
            return `<button (click)="click($event,full)" user-id=${full.primerNombre}>${data}</button>`;
          }
        }
      ],
      // Declare the use of the extension in the dom parameter
      dom: 'Bfrtip',
      // Configure the buttons
      buttons: [
        'columnsToggle',
        'colvis',
        'copy',
        'print',
        'excel',
        {
          text: 'Some button',
          key: '1',
          action: function (e, dt, node, config) {
            alert('Button activated');
          }
        }
      ]
    };
  }

  ngAfterViewInit(){
    console.log(this.table);
    this._render.listenGlobal('document','click',(e)=>{
      if(!e.target.hasAttribute('user-id')) return;
      console.log(e.target.getAttribute('user-id'))
    });
  }

  click(e,full){
    console.log(full)
  }
  
}

